import { render } from "./SkillManageList.vue?vue&type=template&id=b501f1b2&scoped=true"
import script from "./SkillManageList.vue?vue&type=script&lang=js"
export * from "./SkillManageList.vue?vue&type=script&lang=js"

import "./SkillManageList.vue?vue&type=style&index=0&id=b501f1b2&scoped=true&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b501f1b2"]])

export default __exports__